/**
 * Google maps places image loader
 *
 * @package
 */

/**
 * Internal dependencies
 */
import apply from './apply';

/**
 * Load the places images into the relevant blocks
 */
const places = () => {
	apply();
};

export default places;
export { apply };
